import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/resourceTypesFilter/styles.scss';export default {
  "resourceTypesFilter": "_resourceTypesFilter_zt5qm_1",
  "icon": "_icon_zt5qm_5",
  "item": "_item_zt5qm_11",
  "virtual": "_virtual_zt5qm_32",
  "name": "_name_zt5qm_37",
  "selected": "_selected_zt5qm_42"
};